import { render } from "./pick_up.vue?vue&type=template&id=9d004770&scoped=true"
import script from "./pick_up.vue?vue&type=script&lang=js"
export * from "./pick_up.vue?vue&type=script&lang=js"

import "./pick_up.vue?vue&type=style&index=0&id=9d004770&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d004770"]])

export default __exports__